import {
  SET_BIN_LABELS,
  SET_BIN_DIVIDERS,
  SET_CHROMA_ISOLINES,
  SET_REPORT_DATA,
  SET_LIBRARY_DATA,
  SET_LUOX_DATA,
  SET_PASTE_LUOX_DATA,
  SET_LUOX_UNITS,
  DELETE_LIBRARY_ITEM,
  CLEAR_LIBRARY_DATA,
  SET_FULL_REPORT_METADATA,
  DELETE_FULL_REPORT_METADATA,
  SET_GLOBAL_SPINNER,
  SET_GLOBAL_TOAST,
  SET_EXCEL_UPLOAD_ERRORS,
  SET_SHOW_EXCEL_UPLOAD_ERRORS,
} from './types';

const initialState = {
  reportData: {},
  libraryData: [],
  luoxData: {},
  pasteLuoxData: {},
  luoxUnits: {
    absoluteOrRelative: 'absolute',
    radianceOrIrradiance: 'irradiance',
    powerScale: 'mW',
    areaScale: 'm²',
    relativePower: 1,
  },
  excelUploadErrors: [],
  showUploadError: 'hide',
  bin_labels: true,
  bin_dividers: true,
  chroma_isolines: true,
  fullReportMetadataItems: [
    'identifier',
    'manufacturer',
    'creation_date',
    'model',
  ],
  showGlobalSpinner: false,
  showGlobalToast: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_REPORT_DATA:
      const reportData = action.payload.reportData;
      const luoxData = reportData.luoxData?.luoxOutput
        ? {
            shouldCalculateLuoxData: true,
            luoxData: {
              ...reportData.luoxData,
              luoxUnits: initialState.luoxUnits,
            },
          }
        : { shouldCalculateLuoxData: false, luoxData: {} };
      return {
        ...state,
        reportData: reportData,
        ...luoxData,
      };

    case SET_LIBRARY_DATA: {
      let newLibraryItems = [];
      const newLibraryData = action.payload.libraryData;

      newLibraryData.forEach((data, index) => {
        const dataClone = Object.assign({}, data);
        Object.assign(dataClone, {
          id: state.libraryData.length + 1 + index,
        });
        // if (!dataClone.luoxData.luoxUnits) {
        //   Object.assign(dataClone.luoxData, {
        //     luoxUnits: initialState.luoxUnits,
        //   });
        // }
        newLibraryItems.push(dataClone);
      });

      const combinedLibraryData = [...state.libraryData, ...newLibraryItems];
      return {
        ...state,
        libraryData: combinedLibraryData,
      };
    }

    case SET_LUOX_DATA: {
      const luoxData = action.payload.luoxData;
      if (luoxData) {
        return {
          ...state,
          luoxData: luoxData,
        };
      }
      return;
    }

    case SET_PASTE_LUOX_DATA: {
      const pasteLuoxData = action.payload.pasteLuoxData;
      if (pasteLuoxData) {
        return {
          ...state,
          pasteLuoxData: pasteLuoxData,
        };
      }
      return;
    }

    case SET_LUOX_UNITS: {
      const luoxUnits = action.payload.luoxUnits;
      return {
        ...state,
        luoxUnits: luoxUnits ? luoxUnits : initialState.luoxUnits,
      };
    }

    case DELETE_LIBRARY_ITEM: {
      const deleteItemId = action.payload.item;
      const newLibraryData = state.libraryData.slice();
      newLibraryData.splice(deleteItemId - 1, 1);
      newLibraryData.forEach((data) => {
        if (data.id > deleteItemId) {
          Object.assign(data, { id: data.id - 1 });
        }
      });
      return {
        ...state,
        libraryData: newLibraryData,
      };
    }

    case CLEAR_LIBRARY_DATA:
      return {
        ...state,
        libraryData: [],
        libraryInfo: [],
      };

    case SET_BIN_LABELS:
      return {
        ...state,
        bin_labels: !state.bin_labels,
      };

    case SET_BIN_DIVIDERS:
      return {
        ...state,
        bin_dividers: !state.bin_dividers,
      };

    case SET_CHROMA_ISOLINES:
      return {
        ...state,
        chroma_isolines: !state.chroma_isolines,
      };

    case SET_FULL_REPORT_METADATA:
      return {
        ...state,
        fullReportMetadataItems: [
          ...state.fullReportMetadataItems,
          action.payload,
        ],
      };

    case DELETE_FULL_REPORT_METADATA: {
      const id = action.payload;
      const newFullReportMetaData = state.fullReportMetadataItems.slice();
      newFullReportMetaData.splice(id, 1);
      return {
        ...state,
        fullReportMetadataItems: newFullReportMetaData,
      };
    }

    case SET_GLOBAL_SPINNER: {
      const show = action.payload;
      return {
        ...state,
        showGlobalSpinner: show,
      };
    }

    case SET_GLOBAL_TOAST: {
      const toast = action.payload;
      return {
        ...state,
        showGlobalToast: toast,
      };
    }

    case SET_EXCEL_UPLOAD_ERRORS: {
      const newuploadErrors = action.payload.uploadErrors;
      return {
        ...state,
        excelUploadErrors: newuploadErrors
          ? [...state.excelUploadErrors, ...newuploadErrors]
          : [],
      };
    }

    case SET_SHOW_EXCEL_UPLOAD_ERRORS: {
      const showError = action.payload.showError;
      return {
        ...state,
        showUploadError: showError,
      };
    }

    default:
      return state;
  }
}
